import React, { useEffect, useState } from 'react';
import { MultiSelect } from '../../../UI/MultiSelect/MultiSelect';
import OInput from '../../../UI/FormControls/OInput';
import MyButton from '../../../UI/myButton/MyButton';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import { Height } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FilterProdavnica = ({
  filterData,
  setFilterData,
  listaMasina,
  filterMasine,
}) => {
  const { t, i18n } = useTranslation();
  const handleChange = (e) => {
    setFilterData((curr) => {
      return { ...curr, uslovPretrage: e.target.value };
    });
  };

  const handleClickMultipleMasine = (e) => {
    //   const findIsIn = formData.listaOsoba.find((item) => item.id === e.id);
    //   if (findIsIn) {
    //     setFormData((curr) => {
    //       return {
    //         ...curr,
    //         listaOsoba: formData.listaOsoba.filter(
    //           (item) => item.id !== e.id,
    //         ),
    //       };
    //     });
    //     return;
    //   }
    //   setFormData((curr) => {
    //     return {
    //       ...curr,
    //       listaOsoba: [
    //         ...formData.listaOsoba,
    //         { id: e.id, naziv: e.vrednost },
    //       ],
    //     };
    //   });
  };
  const handleClickZaposleni = (e) => {
    setFilterData((curr) => {
      return { ...curr, lista: e };
    });
  };
  return (
    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
      <OInput
        label={t('searchParts')}
        value={filterData.uslovPretrage}
        handleChange={handleChange}
      />
      {/* <OAutocomplete
        data={listaMasina}
        value={formValues.nazivTipa}
        handleClick={handleClickKategorije}
        label="Kategorija"
        style={{ width: '200px' }}
      /> */}
      {/* <div style={{ width: '360px' }}>
        <MultiSelect
          label="Lista masina"
          name="listaMasina"
          data={listaMasina}
          // touched={formData.touchedObukuZavrsili}
          // setTouched={() => {
          //   setFormData((curr) => {
          //     return { ...curr, touchedObukuZavrsili: true };
          //   });
          // }}
          handleClick={(e, selecetedItem) =>
            handleClickMultipleMasine(e, selecetedItem)
          }
          value={selectedMasine}
          errorMessage="Obuku zavrsili je obavezno polje"
        />
      </div> */}

      <AutocompleteMulti
        options={listaMasina}
        value={filterData.lista}
        textProperty="vrednost"
        onChange={handleClickZaposleni}
        text={t('selectEquipment')}
        style={{ maxWidth: '500px' }}
      />
      <MyButton
        onClick={filterMasine}
        label="Filter"
        icon="fa fa-search"
        style={{
          backgroundColor: '#ff7c00',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
        }}
      />
    </div>
  );
};

export default FilterProdavnica;
